/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { SectionShell } from '../../atoms/SectionShell/SectionShell';
import type { LimitsSectionProps } from './LimitsSection.types';

export const LimitsSection = ({ topic, className }: LimitsSectionProps) => {
  const { t } = useInt();

  if (!topic.mistakes?.trim()) {
    return null;
  }

  const paragraphs = topic.mistakes.split('\n\n');

  return (
    <SectionShell id="limits" title={t('Limits and common mistakes')} className={className}>
      {paragraphs.map((paragraph, i) => (
        <p key={i}>{paragraph}</p>
      ))}
    </SectionShell>
  );
};
